var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"site-action",attrs:{"to":_vm.to},on:{"click":function($event){return _vm.$emit('click')}}},[_c('base-icon-block',{attrs:{"icon":_vm.icon,"view":"column","align":"center"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }